/**
 * Centralized version management.
 *
 * Bump rules:
 *   PATCH  x.x.↑  – bug fixes, copy edits, minor style tweaks
 *   MINOR  x.↑.0  – new features, new pages, UI enhancements
 *   MAJOR  ↑.0.0  – breaking changes, full redesign, auth system launch
 *
 * Update VERSION and add an entry to CHANGELOG on every meaningful release.
 */

export const VERSION = "2.2.0";

export const CHANGELOG = [
  {
    version: "2.2.0",
    date: "2026-07-16",
    note: "Richer text design — text transform (UPPER/lower/Title), letter spacing, text background box, and automatic line-wrap with configurable max width. Improved CSV parsing (quoted fields, BOM stripping, smarter header detection). Gallery overrides now cover font family, alignment, and letter spacing; position sliders scale to template dimensions. Full codebase audit added (AUDIT.md).",
  },
  {
    version: "2.1.0",
    date: "2026-07-04",
    note: "Admin dashboard — user management, plan pricing editor, role-based access; landing page pricing section; plan configs now stored in DB (admin-configurable)",
  },
  {
    version: "2.0.0",
    date: "2026-07-03",
    note: "Accounts are here — sign up & sign in (JWT) with Free/Pro/Team plan tiers, new Inter + Space Grotesk type system, design preset JSON export/import, preview against real names, a release-notes page, smoother navigation, and accessibility fixes (keyboard focus, reduced-motion)",
  },
  {
    version: "1.2.0",
    date: "2026-06-26",
    note: "Legal pages (About, Terms, Privacy), auth stubs (Coming Soon), footer & navbar redesign, WCAG color improvements",
  },
  {
    version: "1.1.0",
    date: "2026-06-26",
    note: "SVG icon system, landing page redesign with hero visual and How-it-works section, step-icon navbar",
  },
  {
    version: "1.0.0",
    date: "2025-01-01",
    note: "Initial public release — client-side badge generation, Arabic RTL support, ZIP export",
  },
];
